import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';

@Injectable({
  providedIn: 'root'
})
export class RepoApiService {

  // public GET_EXCEL_DATA = environment.apiUrl + '/v2/excelviewer/getData';
  // public GET_FILTER_OPTIONS = environment.apiUrl + '/v2/excelviewer/getOptions';
  public GET_EXCEL_DATA = '/v2/excelviewer/getData';
  public GET_FILTER_OPTIONS = '/v2/excelviewer/getOptions';
  public httpPostOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{}
  };

  constructor(private http:HttpClient, private apiRequest: ApiRequestService) { }

  getExcelData(data){
    return this.apiRequest.request('POST',this.GET_EXCEL_DATA,data);
    // return this.http.post<any>(this.GET_EXCEL_DATA, data, this.httpPostOptions);
  }

  getFilterOptions(data){
    return this.apiRequest.request('POST',this.GET_FILTER_OPTIONS,data);
    // return this.http.post<any>(this.GET_FILTER_OPTIONS, data, this.httpPostOptions);
  }

  editTopline(body){
    return this.apiRequest.request('PUT',"/v2/excelviewer/edit/table",body);
  }
  createTopline(body){
    return this.apiRequest.request('POST',"/v2/excelviewer/create/table",body);
  }

  copyTopline(body){
    return this.apiRequest.request('POST',"/v2/excelviewer/copy/table",body);
  }

  deleteTopline(body){
    return this.apiRequest.request('PUT',"/v2/excelviewer/delete/table",body);
  }

  copySheet(body){
    return this.apiRequest.request('POST',"/v2/excelviewer/copy/sheet",body);
  }

  editSheetName(body){
    return this.apiRequest.request('PUT',"/v2/excelviewer/editName/sheet",body);
  }

  editSheetTopCut(body){
    return this.apiRequest.request('PUT',"/v2/excelviewer/edit/sheet-topcut ",body);
  }

  deleteSheet(body){
    return this.apiRequest.request('PUT',"/v2/excelviewer/delete/sheet",body);
  }

  downloadFile(body){
    return this.apiRequest.request('POST',"/v2/excelviewer/getDownloadFile",body);
  }

  getDownloadSettingTheme(){
    return this.apiRequest.request('GET',"/v2/excelviewer/getThemes");
  }

  saveDownloadSettings(body){
    return this.apiRequest.request('POST',"/v2/excelviewer/saveSettings/download",body);
  }

  renameFileName(body){
    return this.apiRequest.request('POST',"/v2/repo/renameFile",body);
  }


  copyFile(body){
    return this.apiRequest.request('POST',"/v2/repo/copyFile",body);
  }


  moveFile(body){
    return this.apiRequest.request('POST',"/v2/repo/moveFile",body);
  }

  setKpiRowPriority(body){
    return this.apiRequest.request('POST',"/v2/excelviewer/savePriorities/row",body);
  }

  setKpiColumnPriority(body){
    return this.apiRequest.request('POST',"/v2/excelviewer/saveColumnPriorities",body);
  }

  setKpiPriority(body){
    return this.apiRequest.request('POST',"/v2/excelviewer/savePriorities/table",body);
  }

  changeDataSourceTableList(body){
    return this.apiRequest.request('POST',"/v2/excelviewer/changeDataSource",body);
  }


  getDataSourceTablesList(uuid){
    return this.apiRequest.request('GET',`/v2/tableextraction/getDataTablesList?id=${uuid}`);
  }


  groupTableInKpis(body){
    return this.apiRequest.request('POST',"/v2/excelviewer/groupKpi",body);
  }


  updategroupTableInKpis(body){
    return this.apiRequest.request('PUT',"/v2/excelviewer/groupKpi",body);
  }


  copyGroupInTopline(body){
    return this.apiRequest.request('POST',"/v2/excelviewer/copy/group",body);
  }


  mergeKpiFile(body){
    return this.apiRequest.request('POST',"/v2/excelviewer/mergeKpiFile",body);
  }


  deleteGroupInTopline(body){
    return this.apiRequest.request('PUT',"/v2/excelviewer/delete/group",body);
  }

  getDataTablesList(excelviewer_fileUUID){
    return this.apiRequest.request('GET',`/v2/tableextraction/getDataTablesList?id=${excelviewer_fileUUID}&type=kpiViewer`);
  }

  // getdownloadAll(studyId){
  //   let body = {study_id:studyId};
  //   return this.apiRequest.request('POST','/v2/repo/getfileurldownload/multiple',body);
  // }

  getdownloadAll(studyId){
    let body = {study_id:studyId};
    return this.apiRequest.request('POST','/v2/repo/getfileurldownload/link',body);
  }



}
